module.exports = __webpack_public_path__ + "img/problem4.28592d1f.png";